export const TIPO_MASCOTA = ["PERRO", "GATO", "OTRO"];
export const SEXO_MASCOTA = ["MACHO", "HEMBRA"];
export const TAMANO_MASCOTA = [
  "MUY_PEQUENO",
  "PEQUENO",
  "MEDIANO",
  "GRANDE",
  "MUY_GRANDE",
];
export const COLOR_PELAJE = [
  "NEGRO",
  "BLANCO",
  "MARRON",
  "CAFE_CLARO",
  "BEIGE",
  "CREMA",
  "DORADO",
  "AMARILLO",
  "ROJIZO",
  "GRIS",
  "CANELA",
  "ATIGRADO",
  "MANCHADO",
];
export const ESTADO_MASCOTA = ["BIEN", "HERIDA", "ASUSTADA"];
